'use client';
import { usePathname } from 'next/navigation';
import React from 'react';
export default function usePathChanged(cb) {
    const pathname = usePathname();
    const prevPathnameRef = React.useRef(undefined);
    React.useEffect(()=>{
        if (pathname !== prevPathnameRef.current) {
            prevPathnameRef.current = pathname;
            let result = undefined;
            if (typeof cb === 'function') {
                result = cb(pathname);
            }
            return result;
        }
        return undefined;
    }, [
        cb,
        pathname
    ]);
    return null;
}

//# sourceMappingURL=usePathChanged.js.map